var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard-security-view"}},[_c('span',{staticClass:"dashboard-title mb-5"},[_vm._v("Account Security")]),_c('div',{staticClass:"dashboard-boxed-container mb-4"},[_c('TwoFactorAuthentication')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }